import { useState } from "react"
import { useParams } from 'react-router-dom';
import { useRemoveOfferFromProposalMutation } from "../../proposals/proposalsApi";
import { t } from "../../../utilities/translator";
import Modal from "../../../components/popup/Modal";
import Button from "../../../components/button/Button";

type Props = {
  offerId: string,
}

const DeleteFromProposal = ({
  offerId,
}: Props) => {
  const { id } = useParams<{ id: string }>();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [removeOffer, { isLoading }] = useRemoveOfferFromProposalMutation()

  const handleDelete = async () => {
    const user = JSON.parse(localStorage.getItem('hf_user') || '{}');
    removeOffer({
      proposalId: Number(id),
      offerId,
      muid: user?.user?.muid,
    }).then(() => {
      setShowModal(false)
    })
  }

  return (
    <div>
      <div className="location-icons-wrap" onClick={() => setShowModal(true)}>
        <i className="ri-subtract-line" />
      </div>
      <Modal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        customClass={'proposal-remove-modal'}
        dontClose={isLoading}
      >
        <div className="prm-content flex flex-col gap-7">
          <div className="prm-main flex flex-col gap-6 justify-center items-center">
            <div className="prm-icon"><i className="ri-error-warning-line" /></div>
            <div className="prm-txt flex flex-col gap-1 text-center">
              <b>{t('proposals.removeOfferModal.title')}</b>
              <span>{t('proposals.removeOfferModal.subtitle')}</span>
            </div>
          </div>
          <div className="prm-btns flex gap-3 items-center justify-between">
            <Button
              label={t('proposals.cancel')}
              onClick={() => setShowModal(false)}
              size="lg"
              type="secondary"
              disabled={isLoading}
            />
            <Button
              label={t('proposals.removeOfferModal.confirm')}
              onClick={handleDelete}
              size="lg"
              type="primary"
              disabled={isLoading}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default DeleteFromProposal
